<script lang="ts">
  import { Cuentas, Pacientes, type Cuenta } from '../../../lib/api';
  import { mapaNombresPaciente } from '../../../lib/nombres';

  let { limit = 6 }: { limit?: number } = $props();
  let cuentas = $state<Cuenta[]>([]);
  let nombres = $state<Record<string, string>>({});
  let error = $state<string | null>(null);

  async function cargar() {
    error = null;
    try {
      const [all, pacs] = await Promise.all([Cuentas.list(), Pacientes.list().catch(() => [])]);
      nombres = mapaNombresPaciente(pacs);
      cuentas = all.filter(c => c.estado === 'ABIERTA' || !c.estado).slice(0, limit);
    } catch (e: any) {
      error = e?.message ?? String(e);
    }
  }

  $effect(() => { cargar(); const t = setInterval(cargar, 60000); return () => clearInterval(t); });
</script>

<div class="panel">
  <header><h3>Cuentas abiertas</h3><button type="button" onclick={cargar}>↻</button></header>
  {#if error}<p class="err">{error}</p>{/if}
  {#if cuentas.length === 0 && !error}<p class="empty">Sin cuentas abiertas.</p>{:else}
    <ul>
      {#each cuentas as c (c.id)}
        <li>
          <strong>Q {(c.total ?? 0).toLocaleString('es-GT', { minimumFractionDigits: 2 })}</strong>
          <span>{nombres[c.pacienteId] || 'Paciente'} · {c.estado ?? 'ABIERTA'}</span>
        </li>
      {/each}
    </ul>
  {/if}
</div>

<style>
  .panel { border: 1px solid var(--border); border-radius: var(--radius-md); background: var(--bg-elevated); }
  header { display: flex; justify-content: space-between; padding: 0.65rem 0.85rem; border-bottom: 1px solid var(--border); }
  h3 { margin: 0; font-size: 0.9rem; }
  header button { border: 1px solid var(--border); background: var(--bg-surface); border-radius: 6px; cursor: pointer; padding: 0.2rem 0.5rem; }
  ul { list-style: none; margin: 0; padding: 0; max-height: 240px; overflow: auto; }
  li { padding: 0.6rem 0.85rem; border-bottom: 1px solid var(--border); display: flex; flex-direction: column; gap: 0.1rem; }
  strong { font-size: 0.85rem; color: var(--brand-deep); }
  span { font-size: 0.78rem; color: var(--text-secondary); }
  .empty, .err { padding: 0.85rem; font-size: 0.85rem; margin: 0; }
  .err { color: var(--danger); }
</style>
